// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-color: #ffffff;
  /* color: #CCCCFF */
}
/* .detail-content {
    background-color: #F5F5F5;
    
    
} */

.no-context-menu {
  pointer-events: none;
}

.activeenroll {
  background-color: #156614;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  cursor: pointer;
  border-radius: 10px;
  color: #ffffff;
}

.inactiveenroll {
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  cursor: pointer;
}

.shownotenroll {
  position: fixed;
  top: 125px;
  left: 0;
  background-color: #14b149;
  color: #ffffff;
  width: 100%;
  padding-top: 5px;
  padding-bottom: 5px;
}

.hidenotenroll {
  position: fixed;
  top: 125px;
  left: 0;
  background-color: #14b149;
  color: #ffffff;
  width: 0px;
  padding-top: 5px;
  padding-bottom: 5px;
}

.shownot2enroll {
  position: fixed;
  top: 125px;
  left: 0;
  background-color: #d33d29;
  color: #ffffff;
  width: 100%;
  padding-top: 5px;
  padding-bottom: 5px;
}

.hidenot2enroll {
  position: fixed;
  top: 125px;
  left: 0;
  background-color: #d33d29;
  color: #ffffff;
  width: 0px;
  padding-top: 5px;
  padding-bottom: 5px;
}

.firsttopenroll {
  padding-top: 170px;
}

.Enroll-top {
  margin-top: 10px;
}

.firstarrow {
  position: absolute;
  left: 39.1%;
  top: 148px;
}

.firstarrow2nd {
  width: 156px;
  height: 3px;
  background-color: #156614;
}

/* second arrow */
.secondarrow {
  position: absolute;
  left: 53.5%;
  top: 148px;
}

.secondarrow2nd {
  width: 155px;
  height: 3px;
  background-color: #96c596;
}

.firstarrow2 {
  position: absolute;
  left: 39.3%;
  top: 148px;
}

.secondarrow2 {
  position: absolute;
  left: 53.5%;
  top: 148px;
}

.firstarrow21st {
  width: 153px;
  height: 3px;
  background-color: #156614;
}

.secondarrow21st {
  width: 155px;
  height: 3px;
  background-color: #96c596;
}

.firstarrow3 {
  position: absolute;
  left: 39.3%;
  top: 148px;
}

.secondarrow3 {
  position: absolute;
  left: 53.5%;
  top: 148px;
}

.thirdarrow3 {
  width: 154px;
  height: 3px;
  background-color: #156614;
}

.thirdarrow32 {
  width: 154px;
  height: 3px;
  background-color: #96c596;
}

.Enroll-top2 {
  margin-top: 150px;
}

/* .Enroll-top {
    margin-left: 250px; 
    margin-right: 250px;
} */

.Enroll-page {
  background-color: #ffffff;
  z-index: 100;
  width: "100%";
}

.textinputs2 {
  border-radius: 10px;
  background-color: #edecf8;
  border: 1px solid #dd3a3a;
  height: 40px;
  width: 240px;
}

.textinputs {
  border-radius: 10px;
  display: block;
  background-color: #edecf8;
  border: 1px solid #edecf8;
  height: 40px;
  width: 240px;
}

.newtextinputs {
  border-radius: 10px;
  background-color: #edecf8;
  border: 1px solid #edecf8;
  height: 40px;
  width: 240px;
}

.textarea {
  border-radius: 10px;
  background-color: #edecf8;
  border: 1px solid #edecf8;
}

.textinputs2p {
  border-radius: 10px;
  border: 1px solid #dd3a3a;
  height: 38px;
  width: 303px;
}

.textinputsp {
  border-radius: 10px;
  border: 1px solid #dd3a3a00;
  display: block;
  height: 38px;
  width: 290px;
}

.errortext {
  color: #000000;
}

.errortext2 {
  color: #dd3a3a;
}

input:focus {
  outline: none !important;
  outline-width: 0 !important;
  box-shadow: none;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
}

.formbtn {
  width: 100px;
  height: 35px;

  margin-top: 15px;
  background-color: #156614;
  font-size: 13px;
}

.firstcontent {
  margin-top: 70px;
  margin-bottom: 70px;
  margin-left: 70px;
  margin-right: 5px;
}

.secondcontent {
  margin-top: 70px;
  margin-bottom: 70px;
  margin-left: 70px;
  margin-right: 5px;
}

.myfirstcon {
  margin-top: 70px;
  margin-bottom: 70px;
  margin-left: 70px;
  margin-right: 5px;
}

.sideshifft {
  margin: "70px";
}

.successtabs {
  margin-top: 150px;
  margin-bottom: 100px;
  margin-left: 170px;
  margin-right: 5px;
}

.icantpaynow {
  margin-top: 5px;
  color: #156614;
  cursor: pointer;
}

.icantpaynow:hover {
  color: #25c722;
  cursor: pointer;
}

@media (min-width: 297px) and (max-width: 385px) {
  .firsttopenroll {
    padding-top: 230px;
  }

  .firstarrow {
    position: absolute;
    left: 37.9%;
    top: 215px;
  }

  .firstarrow1st {
    font-size: 12px;
  }

  .firstarrow2nd {
    width: 52px;
    height: 3px;
    background-color: #156614;
  }

  .secondarrow {
    position: absolute;
    left: 63.2%;
    top: 215px;
  }

  .secondarrow2nd {
    width: 52px;
  }

  .secondarrow21st {
    width: 52px;
  }

  /* second arrow */

  .firstarrow2 {
    position: absolute;
    left: 37.7%;
    top: 215px;
  }

  .secondarrow2 {
    position: absolute;
    left: 63.2%;
    top: 215px;
  }

  .firstarrow21st {
    width: 53px;
    height: 3px;
    background-color: #156614;
  }

  .firstarrow3 {
    position: absolute;
    left: 37.7%;
    top: 215px;
  }

  .thirdarrow3 {
    width: 53px;
  }

  .secondarrow3 {
    position: absolute;
    left: 63.2%;
    top: 215px;
  }

  .thirdarrow32 {
    width: 53px;
    height: 3px;
    background-color: #96c596;
  }

  .Enroll-top2 {
    margin-top: 150px;
  }

  /* .Enroll-top {
        margin-left: 250px; 
        margin-right: 250px;
    } */

  .Enroll-page {
    background-color: #ffffff;
    z-index: 100;
    width: "100%";
  }

  .myfirstcon {
    margin-top: 70px;
    margin-bottom: 70px;
    margin-left: 20px;
    margin-right: 5px;
  }

  .sideshifft {
    margin: "50px";
  }

  .textinputs {
    border-radius: 10px;
    background-color: #edecf8;
    border: 1px solid #edecf8;
    height: 40px;
    width: 240px;
  }

  input:focus {
    outline: none !important;
    outline-width: 0 !important;
    box-shadow: none;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
  }

  .formbtn {
    width: 100px;
    height: 35px;

    margin-top: 15px;
    background-color: #156614;
    font-size: 13px;
  }

  .firstcontent {
    margin-top: 70px;
    margin-bottom: 70px;
    margin-left: 20px;
    margin-right: 5px;
  }

  .secondcontent {
    margin-top: 70px;
    margin-bottom: 70px;
    margin-left: 20px;
    margin-right: 5px;
  }

  .successtabs {
    margin-top: 150px;
    margin-bottom: 100px;
    margin-left: 50px;
    margin-right: 5px;
  }
}

@media (min-width: 387px) and (max-width: 585px) {
  .firsttopenroll {
    padding-top: 230px;
  }

  .firstarrow {
    position: absolute;
    left: 37.9%;
    top: 215px;
  }

  .firstarrow1st {
    font-size: 12px;
  }

  .firstarrow2nd {
    width: 52px;
    height: 3px;
    background-color: #156614;
  }

  .secondarrow {
    position: absolute;
    left: 63.2%;
    top: 215px;
  }

  .secondarrow2nd {
    width: 52px;
  }

  .secondarrow21st {
    width: 52px;
  }

  /* second arrow */

  .firstarrow2 {
    position: absolute;
    left: 37.7%;
    top: 215px;
  }

  .secondarrow2 {
    position: absolute;
    left: 63.2%;
    top: 215px;
  }

  .firstarrow21st {
    width: 53px;
    height: 3px;
    background-color: #156614;
  }

  .firstarrow3 {
    position: absolute;
    left: 37.7%;
    top: 215px;
  }

  .thirdarrow3 {
    width: 53px;
  }

  .secondarrow3 {
    position: absolute;
    left: 63.2%;
    top: 215px;
  }

  .thirdarrow32 {
    width: 53px;
    height: 3px;
    background-color: #96c596;
  }

  .Enroll-top2 {
    margin-top: 150px;
  }

  /* .Enroll-top {
        margin-left: 250px; 
        margin-right: 250px;
    } */

  .Enroll-page {
    background-color: #ffffff;
    z-index: 100;
    width: "100%";
  }

  .myfirstcon {
    margin-top: 70px;
    margin-bottom: 70px;
    margin-left: 20px;
    margin-right: 5px;
  }

  .sideshifft {
    margin: "50px";
  }

  .textinputs {
    border-radius: 10px;
    background-color: #edecf8;
    border: 1px solid #edecf8;
    height: 40px;
    width: 240px;
  }

  input:focus {
    outline: none !important;
    outline-width: 0 !important;
    box-shadow: none;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
  }

  .formbtn {
    width: 100px;
    height: 35px;

    margin-top: 15px;
    background-color: #156614;
    font-size: 13px;
  }

  .firstcontent {
    margin-top: 70px;
    margin-bottom: 70px;
    margin-left: 20px;
    margin-right: 5px;
  }

  .secondcontent {
    margin-top: 70px;
    margin-bottom: 70px;
    margin-left: 20px;
    margin-right: 5px;
  }

  .successtabs {
    margin-top: 150px;
    margin-bottom: 100px;
    margin-left: 50px;
    margin-right: 5px;
  }
}

@media (min-width: 597px) and (max-width: 990px) {
  .firsttopenroll {
    padding-top: 180px;
  }

  .firstarrow {
    position: absolute;
    left: 42.8%;
    top: 165px;
  }

  .firstarrow1st {
    font-size: 12px;
  }

  .firstarrow2nd {
    width: 52px;
    height: 3px;
    background-color: #156614;
  }

  .secondarrow {
    position: absolute;
    left: 58.2%;
    top: 165px;
  }

  .secondarrow2nd {
    width: 52px;
  }

  .secondarrow21st {
    width: 52px;
  }

  /* second arrow */

  .firstarrow2 {
    position: absolute;
    left: 42.8%;
    top: 165px;
  }

  .secondarrow2 {
    position: absolute;
    left: 58.2%;
    top: 165px;
  }

  .firstarrow21st {
    width: 53px;
    height: 3px;
    background-color: #156614;
  }

  .firstarrow3 {
    position: absolute;
    left: 42.8%;
    top: 165px;
  }

  .thirdarrow3 {
    width: 53px;
  }

  .secondarrow3 {
    position: absolute;
    left: 58.2%;
    top: 165px;
  }

  .thirdarrow32 {
    width: 53px;
    height: 3px;
    background-color: #96c596;
  }

  .Enroll-top2 {
    margin-top: 150px;
  }

  /* .Enroll-top {
        margin-left: 250px; 
        margin-right: 250px;
    } */

  .Enroll-page {
    background-color: #ffffff;
    z-index: 100;
    width: "100%";
  }

  .myfirstcon {
    margin-top: 70px;
    margin-bottom: 70px;
    margin-left: 20px;
    margin-right: 5px;
  }

  .sideshifft {
    margin: "50px";
  }

  .textinputs {
    border-radius: 10px;
    background-color: #edecf8;
    border: 1px solid #edecf8;
    height: 40px;
    width: 240px;
  }

  input:focus {
    outline: none !important;
    outline-width: 0 !important;
    box-shadow: none;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
  }

  .formbtn {
    width: 100px;
    height: 35px;

    margin-top: 15px;
    background-color: #156614;
    font-size: 13px;
  }

  .firstcontent {
    margin-top: 70px;
    margin-bottom: 70px;
    margin-left: 20px;
    margin-right: 5px;
  }

  .secondcontent {
    margin-top: 70px;
    margin-bottom: 70px;
    margin-left: 20px;
    margin-right: 5px;
  }

  .successtabs {
    margin-top: 150px;
    margin-bottom: 100px;
    margin-left: 50px;
    margin-right: 5px;
  }
}

@media (min-width: 998px) and (max-width: 1090px) {
  .firsttopenroll {
    padding-top: 220px;
  }

  .firstarrow {
    position: absolute;
    left: 42.8%;
    top: 205px;
  }

  .firstarrow1st {
    font-size: 12px;
  }

  .firstarrow2nd {
    width: 52px;
    height: 3px;
    background-color: #156614;
  }

  .secondarrow {
    position: absolute;
    left: 58.2%;
    top: 205px;
  }

  .secondarrow2nd {
    width: 52px;
  }

  .secondarrow21st {
    width: 52px;
  }

  /* second arrow */

  .firstarrow2 {
    position: absolute;
    left: 42.8%;
    top: 205px;
  }

  .secondarrow2 {
    position: absolute;
    left: 58.2%;
    top: 205px;
  }

  .firstarrow21st {
    width: 53px;
    height: 3px;
    background-color: #156614;
  }

  .firstarrow3 {
    position: absolute;
    left: 42.8%;
    top: 205px;
  }

  .thirdarrow3 {
    width: 53px;
  }

  .secondarrow3 {
    position: absolute;
    left: 58.2%;
    top: 205px;
  }

  .thirdarrow32 {
    width: 53px;
    height: 3px;
    background-color: #96c596;
  }

  .Enroll-top2 {
    margin-top: 150px;
  }

  /* .Enroll-top {
        margin-left: 250px; 
        margin-right: 250px;
    } */

  .Enroll-page {
    background-color: #ffffff;
    z-index: 100;
    width: "100%";
  }

  .myfirstcon {
    margin-top: 70px;
    margin-bottom: 70px;
    margin-left: 20px;
    margin-right: 5px;
  }

  .sideshifft {
    margin: "50px";
  }

  .textinputs {
    border-radius: 10px;
    background-color: #edecf8;
    border: 1px solid #edecf8;
    height: 40px;
    width: 240px;
  }

  input:focus {
    outline: none !important;
    outline-width: 0 !important;
    box-shadow: none;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
  }

  .formbtn {
    width: 100px;
    height: 35px;

    margin-top: 15px;
    background-color: #156614;
    font-size: 13px;
  }

  .firstcontent {
    margin-top: 70px;
    margin-bottom: 70px;
    margin-left: 20px;
    margin-right: 5px;
  }

  .secondcontent {
    margin-top: 70px;
    margin-bottom: 70px;
    margin-left: 20px;
    margin-right: 5px;
  }

  .successtabs {
    margin-top: 150px;
    margin-bottom: 100px;
    margin-left: 50px;
    margin-right: 5px;
  }
}

@media (min-width: 1100px) and (max-width: 1290px) {
  .firsttopenroll {
    padding-top: 220px;
  }

  .firstarrow {
    position: absolute;
    left: 42.8%;
    top: 205px;
  }

  .firstarrow1st {
    font-size: 12px;
  }

  .firstarrow2nd {
    width: 52px;
    height: 3px;
    background-color: #156614;
  }

  .secondarrow {
    position: absolute;
    left: 58.2%;
    top: 205px;
  }

  .secondarrow2nd {
    width: 52px;
  }

  .secondarrow21st {
    width: 52px;
  }

  /* second arrow */

  .firstarrow2 {
    position: absolute;
    left: 42.8%;
    top: 205px;
  }

  .secondarrow2 {
    position: absolute;
    left: 58.2%;
    top: 205px;
  }

  .firstarrow21st {
    width: 53px;
    height: 3px;
    background-color: #156614;
  }

  .firstarrow3 {
    position: absolute;
    left: 42.8%;
    top: 205px;
  }

  .thirdarrow3 {
    width: 53px;
  }

  .secondarrow3 {
    position: absolute;
    left: 58.2%;
    top: 205px;
  }

  .thirdarrow32 {
    width: 53px;
    height: 3px;
    background-color: #96c596;
  }

  .Enroll-top2 {
    margin-top: 150px;
  }

  /* .Enroll-top {
        margin-left: 250px; 
        margin-right: 250px;
    } */

  .Enroll-page {
    background-color: #ffffff;
    z-index: 100;
    width: "100%";
  }

  .myfirstcon {
    margin-top: 70px;
    margin-bottom: 70px;
    margin-left: 20px;
    margin-right: 5px;
  }

  .sideshifft {
    margin: "50px";
  }

  .textinputs {
    border-radius: 10px;
    background-color: #edecf8;
    border: 1px solid #edecf8;
    height: 40px;
    width: 240px;
  }

  input:focus {
    outline: none !important;
    outline-width: 0 !important;
    box-shadow: none;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
  }

  .formbtn {
    width: 100px;
    height: 35px;

    margin-top: 15px;
    background-color: #156614;
    font-size: 13px;
  }

  .firstcontent {
    margin-top: 70px;
    margin-bottom: 70px;
    margin-left: 20px;
    margin-right: 5px;
  }

  .secondcontent {
    margin-top: 70px;
    margin-bottom: 70px;
    margin-left: 20px;
    margin-right: 5px;
  }

  .successtabs {
    margin-top: 150px;
    margin-bottom: 100px;
    margin-left: 50px;
    margin-right: 5px;
  }
}

/* 90% screen */
@media (min-width: 1400px) and (max-width: 1590px) {
  .firsttopenroll {
    padding-top: 170px;
  }

  .firstarrow {
    position: absolute;
    left: 38.4%;
    top: 148px;
  }

  .firstarrow2nd {
    width: 182px;
    height: 3px;
    background-color: #156614;
  }

  /* second arrow */
  .secondarrow {
    position: absolute;
    left: 53.2%;
    top: 148px;
  }

  .secondarrow2nd {
    width: 183px;
    height: 3px;
    background-color: #96c596;
  }

  .firstarrow2 {
    position: absolute;
    left: 38.3%;
    top: 148px;
  }

  .secondarrow2 {
    position: absolute;
    left: 53.2%;
    top: 148px;
  }

  .firstarrow21st {
    width: 184px;
    height: 3px;
    background-color: #156614;
  }

  .secondarrow21st {
    width: 184px;
    height: 3px;
    background-color: #96c596;
  }

  .firstarrow3 {
    position: absolute;
    left: 38.3%;
    top: 148px;
  }

  .secondarrow3 {
    position: absolute;
    left: 53.2%;
    top: 148px;
  }

  .thirdarrow3 {
    width: 184px;
    height: 3px;
    background-color: #156614;
  }

  .thirdarrow32 {
    width: 183px;
    height: 3px;
    background-color: #96c596;
  }

  .Enroll-top2 {
    margin-top: 150px;
  }

  /* .Enroll-top {
        margin-left: 250px; 
        margin-right: 250px;
    } */

  .Enroll-page {
    background-color: #ffffff;
    z-index: 100;
    width: "100%";
  }

  .myfirstcon {
    margin-top: 70px;
    margin-bottom: 70px;
    margin-left: 20px;
    margin-right: 5px;
  }

  .sideshifft {
    margin: "50px";
  }

  .textinputs {
    border-radius: 10px;
    background-color: #edecf8;
    border: 1px solid #edecf8;
    height: 40px;
    width: 240px;
  }

  input:focus {
    outline: none !important;
    outline-width: 0 !important;
    box-shadow: none;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
  }

  .formbtn {
    width: 100px;
    height: 35px;

    margin-top: 15px;
    background-color: #156614;
    font-size: 13px;
  }

  .firstcontent {
    margin-top: 70px;
    margin-bottom: 70px;
    margin-left: 20px;
    margin-right: 5px;
  }

  .secondcontent {
    margin-top: 70px;
    margin-bottom: 70px;
    margin-left: 20px;
    margin-right: 5px;
  }

  .successtabs {
    margin-top: 150px;
    margin-bottom: 100px;
    margin-left: 50px;
    margin-right: 5px;
  }
}

/* 80% screen */
@media (min-width: 1600px) and (max-width: 1740px) {
  .firsttopenroll {
    padding-top: 170px;
  }

  .firstarrow {
    position: absolute;
    left: 39.6%;
    top: 148px;
  }

  .firstarrow2nd {
    width: 183px;
    height: 3px;
    background-color: #156614;
  }

  /* second arrow */
  .secondarrow {
    position: absolute;
    left: 52.8%;
    top: 148px;
  }

  .secondarrow2nd {
    width: 183px;
    height: 3px;
    background-color: #96c596;
  }

  .firstarrow2 {
    position: absolute;
    left: 39.6%;
    top: 148px;
  }

  .secondarrow2 {
    position: absolute;
    left: 52.8%;
    top: 148px;
  }

  .firstarrow21st {
    width: 184px;
    height: 3px;
    background-color: #156614;
  }

  .secondarrow21st {
    width: 184px;
    height: 3px;
    background-color: #96c596;
  }

  .firstarrow3 {
    position: absolute;
    left: 39.6%;
    top: 148px;
  }

  .secondarrow3 {
    position: absolute;
    left: 52.8%;
    top: 148px;
  }

  .thirdarrow3 {
    width: 184px;
    height: 3px;
    background-color: #156614;
  }

  .thirdarrow32 {
    width: 183px;
    height: 3px;
    background-color: #96c596;
  }

  .Enroll-top2 {
    margin-top: 150px;
  }

  /* .Enroll-top {
        margin-left: 250px; 
        margin-right: 250px;
    } */

  .Enroll-page {
    background-color: #ffffff;
    z-index: 100;
    width: "100%";
  }

  .myfirstcon {
    margin-top: 70px;
    margin-bottom: 70px;
    margin-left: 20px;
    margin-right: 5px;
  }

  .sideshifft {
    margin: "50px";
  }

  .textinputs {
    border-radius: 10px;
    background-color: #edecf8;
    border: 1px solid #edecf8;
    height: 40px;
    width: 240px;
  }

  input:focus {
    outline: none !important;
    outline-width: 0 !important;
    box-shadow: none;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
  }

  .formbtn {
    width: 100px;
    height: 35px;

    margin-top: 15px;
    background-color: #156614;
    font-size: 13px;
  }

  .firstcontent {
    margin-top: 70px;
    margin-bottom: 70px;
    margin-left: 20px;
    margin-right: 5px;
  }

  .secondcontent {
    margin-top: 70px;
    margin-bottom: 70px;
    margin-left: 20px;
    margin-right: 5px;
  }

  .successtabs {
    margin-top: 150px;
    margin-bottom: 100px;
    margin-left: 50px;
    margin-right: 5px;
  }
}

/* 75% screen */
@media (min-width: 1790px) and (max-width: 1890px) {
  .firsttopenroll {
    padding-top: 170px;
  }

  .firstarrow {
    position: absolute;
    left: 40.3%;
    top: 148px;
  }

  .firstarrow2nd {
    width: 183px;
    height: 3px;
    background-color: #156614;
  }

  /* second arrow */
  .secondarrow {
    position: absolute;
    left: 52.7%;
    top: 148px;
  }

  .secondarrow2nd {
    width: 183px;
    height: 3px;
    background-color: #96c596;
  }

  .firstarrow2 {
    position: absolute;
    left: 40.3%;
    top: 148px;
  }

  .secondarrow2 {
    position: absolute;
    left: 52.7%;
    top: 148px;
  }

  .firstarrow21st {
    width: 184px;
    height: 3px;
    background-color: #156614;
  }

  .secondarrow21st {
    width: 184px;
    height: 3px;
    background-color: #96c596;
  }

  .firstarrow3 {
    position: absolute;
    left: 40.3%;
    top: 148px;
  }

  .secondarrow3 {
    position: absolute;
    left: 52.6%;
    top: 148px;
  }

  .thirdarrow3 {
    width: 184px;
    height: 3px;
    background-color: #156614;
  }

  .thirdarrow32 {
    width: 183px;
    height: 3px;
    background-color: #96c596;
  }

  .Enroll-top2 {
    margin-top: 150px;
  }

  /* .Enroll-top {
        margin-left: 250px; 
        margin-right: 250px;
    } */

  .Enroll-page {
    background-color: #ffffff;
    z-index: 100;
    width: "100%";
  }

  .myfirstcon {
    margin-top: 70px;
    margin-bottom: 70px;
    margin-left: 20px;
    margin-right: 5px;
  }

  .sideshifft {
    margin: "50px";
  }

  .textinputs {
    border-radius: 10px;
    background-color: #edecf8;
    border: 1px solid #edecf8;
    height: 40px;
    width: 240px;
  }

  input:focus {
    outline: none !important;
    outline-width: 0 !important;
    box-shadow: none;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
  }

  .formbtn {
    width: 100px;
    height: 35px;

    margin-top: 15px;
    background-color: #156614;
    font-size: 13px;
  }

  .firstcontent {
    margin-top: 70px;
    margin-bottom: 70px;
    margin-left: 20px;
    margin-right: 5px;
  }

  .secondcontent {
    margin-top: 70px;
    margin-bottom: 70px;
    margin-left: 20px;
    margin-right: 5px;
  }

  .successtabs {
    margin-top: 150px;
    margin-bottom: 100px;
    margin-left: 50px;
    margin-right: 5px;
  }
}

/* 67% screen */
@media (min-width: 1900px) and (max-width: 3000px) {
  .firsttopenroll {
    padding-top: 170px;
  }

  .firstarrow {
    position: absolute;
    left: 41.4%;
    top: 148px;
  }

  .firstarrow2nd {
    width: 183px;
    height: 3px;
    background-color: #156614;
  }

  /* second arrow */
  .secondarrow {
    position: absolute;
    left: 52.3%;
    top: 148px;
  }

  .secondarrow2nd {
    width: 183px;
    height: 3px;
    background-color: #96c596;
  }

  .firstarrow2 {
    position: absolute;
    left: 41.3%;
    top: 148px;
  }

  .secondarrow2 {
    position: absolute;
    left: 52.3%;
    top: 148px;
  }

  .firstarrow21st {
    width: 184px;
    height: 3px;
    background-color: #156614;
  }

  .secondarrow21st {
    width: 184px;
    height: 3px;
    background-color: #96c596;
  }

  .firstarrow3 {
    position: absolute;
    left: 41.3%;
    top: 148px;
  }

  .secondarrow3 {
    position: absolute;
    left: 52.3%;
    top: 148px;
  }

  .thirdarrow3 {
    width: 184px;
    height: 3px;
    background-color: #156614;
  }

  .thirdarrow32 {
    width: 183px;
    height: 3px;
    background-color: #96c596;
  }

  .Enroll-top2 {
    margin-top: 150px;
  }

  /* .Enroll-top {
        margin-left: 250px; 
        margin-right: 250px;
    } */

  .Enroll-page {
    background-color: #ffffff;
    z-index: 100;
    width: "100%";
  }

  .myfirstcon {
    margin-top: 70px;
    margin-bottom: 70px;
    margin-left: 20px;
    margin-right: 5px;
  }

  .sideshifft {
    margin: "50px";
  }

  .textinputs {
    border-radius: 10px;
    background-color: #edecf8;
    border: 1px solid #edecf8;
    height: 40px;
    width: 240px;
  }

  input:focus {
    outline: none !important;
    outline-width: 0 !important;
    box-shadow: none;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
  }

  .formbtn {
    width: 100px;
    height: 35px;

    margin-top: 15px;
    background-color: #156614;
    font-size: 13px;
  }

  .firstcontent {
    margin-top: 70px;
    margin-bottom: 70px;
    margin-left: 20px;
    margin-right: 5px;
  }

  .secondcontent {
    margin-top: 70px;
    margin-bottom: 70px;
    margin-left: 20px;
    margin-right: 5px;
  }

  .successtabs {
    margin-top: 150px;
    margin-bottom: 100px;
    margin-left: 50px;
    margin-right: 5px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/EnrollForm.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;;;;GAIG;;AAEH;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,OAAO;EACP,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,OAAO;EACP,yBAAyB;EACzB,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,OAAO;EACP,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,OAAO;EACP,yBAAyB;EACzB,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;GAGG;;AAEH;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,cAAc;EACd,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,YAAY;;EAEZ,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA,iBAAiB;;EAEjB;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;;OAGK;;EAEL;IACE,yBAAyB;IACzB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,wBAAwB;IACxB,2BAA2B;IAC3B,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;EAC1B;;EAEA;IACE,YAAY;IACZ,YAAY;;IAEZ,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA,iBAAiB;;EAEjB;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;;OAGK;;EAEL;IACE,yBAAyB;IACzB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,wBAAwB;IACxB,2BAA2B;IAC3B,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;EAC1B;;EAEA;IACE,YAAY;IACZ,YAAY;;IAEZ,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA,iBAAiB;;EAEjB;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;;OAGK;;EAEL;IACE,yBAAyB;IACzB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,wBAAwB;IACxB,2BAA2B;IAC3B,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;EAC1B;;EAEA;IACE,YAAY;IACZ,YAAY;;IAEZ,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA,iBAAiB;;EAEjB;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;;OAGK;;EAEL;IACE,yBAAyB;IACzB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,wBAAwB;IACxB,2BAA2B;IAC3B,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;EAC1B;;EAEA;IACE,YAAY;IACZ,YAAY;;IAEZ,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA,iBAAiB;;EAEjB;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;;OAGK;;EAEL;IACE,yBAAyB;IACzB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,wBAAwB;IACxB,2BAA2B;IAC3B,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;EAC1B;;EAEA;IACE,YAAY;IACZ,YAAY;;IAEZ,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA,eAAe;AACf;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,yBAAyB;EAC3B;;EAEA,iBAAiB;EACjB;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;;OAGK;;EAEL;IACE,yBAAyB;IACzB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,wBAAwB;IACxB,2BAA2B;IAC3B,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;EAC1B;;EAEA;IACE,YAAY;IACZ,YAAY;;IAEZ,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA,eAAe;AACf;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,yBAAyB;EAC3B;;EAEA,iBAAiB;EACjB;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;;OAGK;;EAEL;IACE,yBAAyB;IACzB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,wBAAwB;IACxB,2BAA2B;IAC3B,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;EAC1B;;EAEA;IACE,YAAY;IACZ,YAAY;;IAEZ,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA,eAAe;AACf;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,yBAAyB;EAC3B;;EAEA,iBAAiB;EACjB;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;;OAGK;;EAEL;IACE,yBAAyB;IACzB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,wBAAwB;IACxB,2BAA2B;IAC3B,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;EAC1B;;EAEA;IACE,YAAY;IACZ,YAAY;;IAEZ,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA,eAAe;AACf;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,yBAAyB;EAC3B;;EAEA,iBAAiB;EACjB;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;;OAGK;;EAEL;IACE,yBAAyB;IACzB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,wBAAwB;IACxB,2BAA2B;IAC3B,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;EAC1B;;EAEA;IACE,YAAY;IACZ,YAAY;;IAEZ,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;IACjB,iBAAiB;EACnB;AACF","sourcesContent":["body {\n  background-color: #ffffff;\n  /* color: #CCCCFF */\n}\n/* .detail-content {\n    background-color: #F5F5F5;\n    \n    \n} */\n\n.no-context-menu {\n  pointer-events: none;\n}\n\n.activeenroll {\n  background-color: #156614;\n  padding-left: 20px;\n  padding-right: 20px;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  cursor: pointer;\n  border-radius: 10px;\n  color: #ffffff;\n}\n\n.inactiveenroll {\n  padding-left: 20px;\n  padding-right: 20px;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  cursor: pointer;\n}\n\n.shownotenroll {\n  position: fixed;\n  top: 125px;\n  left: 0;\n  background-color: #14b149;\n  color: #ffffff;\n  width: 100%;\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n\n.hidenotenroll {\n  position: fixed;\n  top: 125px;\n  left: 0;\n  background-color: #14b149;\n  color: #ffffff;\n  width: 0px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n\n.shownot2enroll {\n  position: fixed;\n  top: 125px;\n  left: 0;\n  background-color: #d33d29;\n  color: #ffffff;\n  width: 100%;\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n\n.hidenot2enroll {\n  position: fixed;\n  top: 125px;\n  left: 0;\n  background-color: #d33d29;\n  color: #ffffff;\n  width: 0px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n\n.firsttopenroll {\n  padding-top: 170px;\n}\n\n.Enroll-top {\n  margin-top: 10px;\n}\n\n.firstarrow {\n  position: absolute;\n  left: 39.1%;\n  top: 148px;\n}\n\n.firstarrow2nd {\n  width: 156px;\n  height: 3px;\n  background-color: #156614;\n}\n\n/* second arrow */\n.secondarrow {\n  position: absolute;\n  left: 53.5%;\n  top: 148px;\n}\n\n.secondarrow2nd {\n  width: 155px;\n  height: 3px;\n  background-color: #96c596;\n}\n\n.firstarrow2 {\n  position: absolute;\n  left: 39.3%;\n  top: 148px;\n}\n\n.secondarrow2 {\n  position: absolute;\n  left: 53.5%;\n  top: 148px;\n}\n\n.firstarrow21st {\n  width: 153px;\n  height: 3px;\n  background-color: #156614;\n}\n\n.secondarrow21st {\n  width: 155px;\n  height: 3px;\n  background-color: #96c596;\n}\n\n.firstarrow3 {\n  position: absolute;\n  left: 39.3%;\n  top: 148px;\n}\n\n.secondarrow3 {\n  position: absolute;\n  left: 53.5%;\n  top: 148px;\n}\n\n.thirdarrow3 {\n  width: 154px;\n  height: 3px;\n  background-color: #156614;\n}\n\n.thirdarrow32 {\n  width: 154px;\n  height: 3px;\n  background-color: #96c596;\n}\n\n.Enroll-top2 {\n  margin-top: 150px;\n}\n\n/* .Enroll-top {\n    margin-left: 250px; \n    margin-right: 250px;\n} */\n\n.Enroll-page {\n  background-color: #ffffff;\n  z-index: 100;\n  width: \"100%\";\n}\n\n.textinputs2 {\n  border-radius: 10px;\n  background-color: #edecf8;\n  border: 1px solid #dd3a3a;\n  height: 40px;\n  width: 240px;\n}\n\n.textinputs {\n  border-radius: 10px;\n  display: block;\n  background-color: #edecf8;\n  border: 1px solid #edecf8;\n  height: 40px;\n  width: 240px;\n}\n\n.newtextinputs {\n  border-radius: 10px;\n  background-color: #edecf8;\n  border: 1px solid #edecf8;\n  height: 40px;\n  width: 240px;\n}\n\n.textarea {\n  border-radius: 10px;\n  background-color: #edecf8;\n  border: 1px solid #edecf8;\n}\n\n.textinputs2p {\n  border-radius: 10px;\n  border: 1px solid #dd3a3a;\n  height: 38px;\n  width: 303px;\n}\n\n.textinputsp {\n  border-radius: 10px;\n  border: 1px solid #dd3a3a00;\n  display: block;\n  height: 38px;\n  width: 290px;\n}\n\n.errortext {\n  color: #000000;\n}\n\n.errortext2 {\n  color: #dd3a3a;\n}\n\ninput:focus {\n  outline: none !important;\n  outline-width: 0 !important;\n  box-shadow: none;\n  -moz-box-shadow: none;\n  -webkit-box-shadow: none;\n}\n\n.formbtn {\n  width: 100px;\n  height: 35px;\n\n  margin-top: 15px;\n  background-color: #156614;\n  font-size: 13px;\n}\n\n.firstcontent {\n  margin-top: 70px;\n  margin-bottom: 70px;\n  margin-left: 70px;\n  margin-right: 5px;\n}\n\n.secondcontent {\n  margin-top: 70px;\n  margin-bottom: 70px;\n  margin-left: 70px;\n  margin-right: 5px;\n}\n\n.myfirstcon {\n  margin-top: 70px;\n  margin-bottom: 70px;\n  margin-left: 70px;\n  margin-right: 5px;\n}\n\n.sideshifft {\n  margin: \"70px\";\n}\n\n.successtabs {\n  margin-top: 150px;\n  margin-bottom: 100px;\n  margin-left: 170px;\n  margin-right: 5px;\n}\n\n.icantpaynow {\n  margin-top: 5px;\n  color: #156614;\n  cursor: pointer;\n}\n\n.icantpaynow:hover {\n  color: #25c722;\n  cursor: pointer;\n}\n\n@media (min-width: 297px) and (max-width: 385px) {\n  .firsttopenroll {\n    padding-top: 230px;\n  }\n\n  .firstarrow {\n    position: absolute;\n    left: 37.9%;\n    top: 215px;\n  }\n\n  .firstarrow1st {\n    font-size: 12px;\n  }\n\n  .firstarrow2nd {\n    width: 52px;\n    height: 3px;\n    background-color: #156614;\n  }\n\n  .secondarrow {\n    position: absolute;\n    left: 63.2%;\n    top: 215px;\n  }\n\n  .secondarrow2nd {\n    width: 52px;\n  }\n\n  .secondarrow21st {\n    width: 52px;\n  }\n\n  /* second arrow */\n\n  .firstarrow2 {\n    position: absolute;\n    left: 37.7%;\n    top: 215px;\n  }\n\n  .secondarrow2 {\n    position: absolute;\n    left: 63.2%;\n    top: 215px;\n  }\n\n  .firstarrow21st {\n    width: 53px;\n    height: 3px;\n    background-color: #156614;\n  }\n\n  .firstarrow3 {\n    position: absolute;\n    left: 37.7%;\n    top: 215px;\n  }\n\n  .thirdarrow3 {\n    width: 53px;\n  }\n\n  .secondarrow3 {\n    position: absolute;\n    left: 63.2%;\n    top: 215px;\n  }\n\n  .thirdarrow32 {\n    width: 53px;\n    height: 3px;\n    background-color: #96c596;\n  }\n\n  .Enroll-top2 {\n    margin-top: 150px;\n  }\n\n  /* .Enroll-top {\n        margin-left: 250px; \n        margin-right: 250px;\n    } */\n\n  .Enroll-page {\n    background-color: #ffffff;\n    z-index: 100;\n    width: \"100%\";\n  }\n\n  .myfirstcon {\n    margin-top: 70px;\n    margin-bottom: 70px;\n    margin-left: 20px;\n    margin-right: 5px;\n  }\n\n  .sideshifft {\n    margin: \"50px\";\n  }\n\n  .textinputs {\n    border-radius: 10px;\n    background-color: #edecf8;\n    border: 1px solid #edecf8;\n    height: 40px;\n    width: 240px;\n  }\n\n  input:focus {\n    outline: none !important;\n    outline-width: 0 !important;\n    box-shadow: none;\n    -moz-box-shadow: none;\n    -webkit-box-shadow: none;\n  }\n\n  .formbtn {\n    width: 100px;\n    height: 35px;\n\n    margin-top: 15px;\n    background-color: #156614;\n    font-size: 13px;\n  }\n\n  .firstcontent {\n    margin-top: 70px;\n    margin-bottom: 70px;\n    margin-left: 20px;\n    margin-right: 5px;\n  }\n\n  .secondcontent {\n    margin-top: 70px;\n    margin-bottom: 70px;\n    margin-left: 20px;\n    margin-right: 5px;\n  }\n\n  .successtabs {\n    margin-top: 150px;\n    margin-bottom: 100px;\n    margin-left: 50px;\n    margin-right: 5px;\n  }\n}\n\n@media (min-width: 387px) and (max-width: 585px) {\n  .firsttopenroll {\n    padding-top: 230px;\n  }\n\n  .firstarrow {\n    position: absolute;\n    left: 37.9%;\n    top: 215px;\n  }\n\n  .firstarrow1st {\n    font-size: 12px;\n  }\n\n  .firstarrow2nd {\n    width: 52px;\n    height: 3px;\n    background-color: #156614;\n  }\n\n  .secondarrow {\n    position: absolute;\n    left: 63.2%;\n    top: 215px;\n  }\n\n  .secondarrow2nd {\n    width: 52px;\n  }\n\n  .secondarrow21st {\n    width: 52px;\n  }\n\n  /* second arrow */\n\n  .firstarrow2 {\n    position: absolute;\n    left: 37.7%;\n    top: 215px;\n  }\n\n  .secondarrow2 {\n    position: absolute;\n    left: 63.2%;\n    top: 215px;\n  }\n\n  .firstarrow21st {\n    width: 53px;\n    height: 3px;\n    background-color: #156614;\n  }\n\n  .firstarrow3 {\n    position: absolute;\n    left: 37.7%;\n    top: 215px;\n  }\n\n  .thirdarrow3 {\n    width: 53px;\n  }\n\n  .secondarrow3 {\n    position: absolute;\n    left: 63.2%;\n    top: 215px;\n  }\n\n  .thirdarrow32 {\n    width: 53px;\n    height: 3px;\n    background-color: #96c596;\n  }\n\n  .Enroll-top2 {\n    margin-top: 150px;\n  }\n\n  /* .Enroll-top {\n        margin-left: 250px; \n        margin-right: 250px;\n    } */\n\n  .Enroll-page {\n    background-color: #ffffff;\n    z-index: 100;\n    width: \"100%\";\n  }\n\n  .myfirstcon {\n    margin-top: 70px;\n    margin-bottom: 70px;\n    margin-left: 20px;\n    margin-right: 5px;\n  }\n\n  .sideshifft {\n    margin: \"50px\";\n  }\n\n  .textinputs {\n    border-radius: 10px;\n    background-color: #edecf8;\n    border: 1px solid #edecf8;\n    height: 40px;\n    width: 240px;\n  }\n\n  input:focus {\n    outline: none !important;\n    outline-width: 0 !important;\n    box-shadow: none;\n    -moz-box-shadow: none;\n    -webkit-box-shadow: none;\n  }\n\n  .formbtn {\n    width: 100px;\n    height: 35px;\n\n    margin-top: 15px;\n    background-color: #156614;\n    font-size: 13px;\n  }\n\n  .firstcontent {\n    margin-top: 70px;\n    margin-bottom: 70px;\n    margin-left: 20px;\n    margin-right: 5px;\n  }\n\n  .secondcontent {\n    margin-top: 70px;\n    margin-bottom: 70px;\n    margin-left: 20px;\n    margin-right: 5px;\n  }\n\n  .successtabs {\n    margin-top: 150px;\n    margin-bottom: 100px;\n    margin-left: 50px;\n    margin-right: 5px;\n  }\n}\n\n@media (min-width: 597px) and (max-width: 990px) {\n  .firsttopenroll {\n    padding-top: 180px;\n  }\n\n  .firstarrow {\n    position: absolute;\n    left: 42.8%;\n    top: 165px;\n  }\n\n  .firstarrow1st {\n    font-size: 12px;\n  }\n\n  .firstarrow2nd {\n    width: 52px;\n    height: 3px;\n    background-color: #156614;\n  }\n\n  .secondarrow {\n    position: absolute;\n    left: 58.2%;\n    top: 165px;\n  }\n\n  .secondarrow2nd {\n    width: 52px;\n  }\n\n  .secondarrow21st {\n    width: 52px;\n  }\n\n  /* second arrow */\n\n  .firstarrow2 {\n    position: absolute;\n    left: 42.8%;\n    top: 165px;\n  }\n\n  .secondarrow2 {\n    position: absolute;\n    left: 58.2%;\n    top: 165px;\n  }\n\n  .firstarrow21st {\n    width: 53px;\n    height: 3px;\n    background-color: #156614;\n  }\n\n  .firstarrow3 {\n    position: absolute;\n    left: 42.8%;\n    top: 165px;\n  }\n\n  .thirdarrow3 {\n    width: 53px;\n  }\n\n  .secondarrow3 {\n    position: absolute;\n    left: 58.2%;\n    top: 165px;\n  }\n\n  .thirdarrow32 {\n    width: 53px;\n    height: 3px;\n    background-color: #96c596;\n  }\n\n  .Enroll-top2 {\n    margin-top: 150px;\n  }\n\n  /* .Enroll-top {\n        margin-left: 250px; \n        margin-right: 250px;\n    } */\n\n  .Enroll-page {\n    background-color: #ffffff;\n    z-index: 100;\n    width: \"100%\";\n  }\n\n  .myfirstcon {\n    margin-top: 70px;\n    margin-bottom: 70px;\n    margin-left: 20px;\n    margin-right: 5px;\n  }\n\n  .sideshifft {\n    margin: \"50px\";\n  }\n\n  .textinputs {\n    border-radius: 10px;\n    background-color: #edecf8;\n    border: 1px solid #edecf8;\n    height: 40px;\n    width: 240px;\n  }\n\n  input:focus {\n    outline: none !important;\n    outline-width: 0 !important;\n    box-shadow: none;\n    -moz-box-shadow: none;\n    -webkit-box-shadow: none;\n  }\n\n  .formbtn {\n    width: 100px;\n    height: 35px;\n\n    margin-top: 15px;\n    background-color: #156614;\n    font-size: 13px;\n  }\n\n  .firstcontent {\n    margin-top: 70px;\n    margin-bottom: 70px;\n    margin-left: 20px;\n    margin-right: 5px;\n  }\n\n  .secondcontent {\n    margin-top: 70px;\n    margin-bottom: 70px;\n    margin-left: 20px;\n    margin-right: 5px;\n  }\n\n  .successtabs {\n    margin-top: 150px;\n    margin-bottom: 100px;\n    margin-left: 50px;\n    margin-right: 5px;\n  }\n}\n\n@media (min-width: 998px) and (max-width: 1090px) {\n  .firsttopenroll {\n    padding-top: 220px;\n  }\n\n  .firstarrow {\n    position: absolute;\n    left: 42.8%;\n    top: 205px;\n  }\n\n  .firstarrow1st {\n    font-size: 12px;\n  }\n\n  .firstarrow2nd {\n    width: 52px;\n    height: 3px;\n    background-color: #156614;\n  }\n\n  .secondarrow {\n    position: absolute;\n    left: 58.2%;\n    top: 205px;\n  }\n\n  .secondarrow2nd {\n    width: 52px;\n  }\n\n  .secondarrow21st {\n    width: 52px;\n  }\n\n  /* second arrow */\n\n  .firstarrow2 {\n    position: absolute;\n    left: 42.8%;\n    top: 205px;\n  }\n\n  .secondarrow2 {\n    position: absolute;\n    left: 58.2%;\n    top: 205px;\n  }\n\n  .firstarrow21st {\n    width: 53px;\n    height: 3px;\n    background-color: #156614;\n  }\n\n  .firstarrow3 {\n    position: absolute;\n    left: 42.8%;\n    top: 205px;\n  }\n\n  .thirdarrow3 {\n    width: 53px;\n  }\n\n  .secondarrow3 {\n    position: absolute;\n    left: 58.2%;\n    top: 205px;\n  }\n\n  .thirdarrow32 {\n    width: 53px;\n    height: 3px;\n    background-color: #96c596;\n  }\n\n  .Enroll-top2 {\n    margin-top: 150px;\n  }\n\n  /* .Enroll-top {\n        margin-left: 250px; \n        margin-right: 250px;\n    } */\n\n  .Enroll-page {\n    background-color: #ffffff;\n    z-index: 100;\n    width: \"100%\";\n  }\n\n  .myfirstcon {\n    margin-top: 70px;\n    margin-bottom: 70px;\n    margin-left: 20px;\n    margin-right: 5px;\n  }\n\n  .sideshifft {\n    margin: \"50px\";\n  }\n\n  .textinputs {\n    border-radius: 10px;\n    background-color: #edecf8;\n    border: 1px solid #edecf8;\n    height: 40px;\n    width: 240px;\n  }\n\n  input:focus {\n    outline: none !important;\n    outline-width: 0 !important;\n    box-shadow: none;\n    -moz-box-shadow: none;\n    -webkit-box-shadow: none;\n  }\n\n  .formbtn {\n    width: 100px;\n    height: 35px;\n\n    margin-top: 15px;\n    background-color: #156614;\n    font-size: 13px;\n  }\n\n  .firstcontent {\n    margin-top: 70px;\n    margin-bottom: 70px;\n    margin-left: 20px;\n    margin-right: 5px;\n  }\n\n  .secondcontent {\n    margin-top: 70px;\n    margin-bottom: 70px;\n    margin-left: 20px;\n    margin-right: 5px;\n  }\n\n  .successtabs {\n    margin-top: 150px;\n    margin-bottom: 100px;\n    margin-left: 50px;\n    margin-right: 5px;\n  }\n}\n\n@media (min-width: 1100px) and (max-width: 1290px) {\n  .firsttopenroll {\n    padding-top: 220px;\n  }\n\n  .firstarrow {\n    position: absolute;\n    left: 42.8%;\n    top: 205px;\n  }\n\n  .firstarrow1st {\n    font-size: 12px;\n  }\n\n  .firstarrow2nd {\n    width: 52px;\n    height: 3px;\n    background-color: #156614;\n  }\n\n  .secondarrow {\n    position: absolute;\n    left: 58.2%;\n    top: 205px;\n  }\n\n  .secondarrow2nd {\n    width: 52px;\n  }\n\n  .secondarrow21st {\n    width: 52px;\n  }\n\n  /* second arrow */\n\n  .firstarrow2 {\n    position: absolute;\n    left: 42.8%;\n    top: 205px;\n  }\n\n  .secondarrow2 {\n    position: absolute;\n    left: 58.2%;\n    top: 205px;\n  }\n\n  .firstarrow21st {\n    width: 53px;\n    height: 3px;\n    background-color: #156614;\n  }\n\n  .firstarrow3 {\n    position: absolute;\n    left: 42.8%;\n    top: 205px;\n  }\n\n  .thirdarrow3 {\n    width: 53px;\n  }\n\n  .secondarrow3 {\n    position: absolute;\n    left: 58.2%;\n    top: 205px;\n  }\n\n  .thirdarrow32 {\n    width: 53px;\n    height: 3px;\n    background-color: #96c596;\n  }\n\n  .Enroll-top2 {\n    margin-top: 150px;\n  }\n\n  /* .Enroll-top {\n        margin-left: 250px; \n        margin-right: 250px;\n    } */\n\n  .Enroll-page {\n    background-color: #ffffff;\n    z-index: 100;\n    width: \"100%\";\n  }\n\n  .myfirstcon {\n    margin-top: 70px;\n    margin-bottom: 70px;\n    margin-left: 20px;\n    margin-right: 5px;\n  }\n\n  .sideshifft {\n    margin: \"50px\";\n  }\n\n  .textinputs {\n    border-radius: 10px;\n    background-color: #edecf8;\n    border: 1px solid #edecf8;\n    height: 40px;\n    width: 240px;\n  }\n\n  input:focus {\n    outline: none !important;\n    outline-width: 0 !important;\n    box-shadow: none;\n    -moz-box-shadow: none;\n    -webkit-box-shadow: none;\n  }\n\n  .formbtn {\n    width: 100px;\n    height: 35px;\n\n    margin-top: 15px;\n    background-color: #156614;\n    font-size: 13px;\n  }\n\n  .firstcontent {\n    margin-top: 70px;\n    margin-bottom: 70px;\n    margin-left: 20px;\n    margin-right: 5px;\n  }\n\n  .secondcontent {\n    margin-top: 70px;\n    margin-bottom: 70px;\n    margin-left: 20px;\n    margin-right: 5px;\n  }\n\n  .successtabs {\n    margin-top: 150px;\n    margin-bottom: 100px;\n    margin-left: 50px;\n    margin-right: 5px;\n  }\n}\n\n/* 90% screen */\n@media (min-width: 1400px) and (max-width: 1590px) {\n  .firsttopenroll {\n    padding-top: 170px;\n  }\n\n  .firstarrow {\n    position: absolute;\n    left: 38.4%;\n    top: 148px;\n  }\n\n  .firstarrow2nd {\n    width: 182px;\n    height: 3px;\n    background-color: #156614;\n  }\n\n  /* second arrow */\n  .secondarrow {\n    position: absolute;\n    left: 53.2%;\n    top: 148px;\n  }\n\n  .secondarrow2nd {\n    width: 183px;\n    height: 3px;\n    background-color: #96c596;\n  }\n\n  .firstarrow2 {\n    position: absolute;\n    left: 38.3%;\n    top: 148px;\n  }\n\n  .secondarrow2 {\n    position: absolute;\n    left: 53.2%;\n    top: 148px;\n  }\n\n  .firstarrow21st {\n    width: 184px;\n    height: 3px;\n    background-color: #156614;\n  }\n\n  .secondarrow21st {\n    width: 184px;\n    height: 3px;\n    background-color: #96c596;\n  }\n\n  .firstarrow3 {\n    position: absolute;\n    left: 38.3%;\n    top: 148px;\n  }\n\n  .secondarrow3 {\n    position: absolute;\n    left: 53.2%;\n    top: 148px;\n  }\n\n  .thirdarrow3 {\n    width: 184px;\n    height: 3px;\n    background-color: #156614;\n  }\n\n  .thirdarrow32 {\n    width: 183px;\n    height: 3px;\n    background-color: #96c596;\n  }\n\n  .Enroll-top2 {\n    margin-top: 150px;\n  }\n\n  /* .Enroll-top {\n        margin-left: 250px; \n        margin-right: 250px;\n    } */\n\n  .Enroll-page {\n    background-color: #ffffff;\n    z-index: 100;\n    width: \"100%\";\n  }\n\n  .myfirstcon {\n    margin-top: 70px;\n    margin-bottom: 70px;\n    margin-left: 20px;\n    margin-right: 5px;\n  }\n\n  .sideshifft {\n    margin: \"50px\";\n  }\n\n  .textinputs {\n    border-radius: 10px;\n    background-color: #edecf8;\n    border: 1px solid #edecf8;\n    height: 40px;\n    width: 240px;\n  }\n\n  input:focus {\n    outline: none !important;\n    outline-width: 0 !important;\n    box-shadow: none;\n    -moz-box-shadow: none;\n    -webkit-box-shadow: none;\n  }\n\n  .formbtn {\n    width: 100px;\n    height: 35px;\n\n    margin-top: 15px;\n    background-color: #156614;\n    font-size: 13px;\n  }\n\n  .firstcontent {\n    margin-top: 70px;\n    margin-bottom: 70px;\n    margin-left: 20px;\n    margin-right: 5px;\n  }\n\n  .secondcontent {\n    margin-top: 70px;\n    margin-bottom: 70px;\n    margin-left: 20px;\n    margin-right: 5px;\n  }\n\n  .successtabs {\n    margin-top: 150px;\n    margin-bottom: 100px;\n    margin-left: 50px;\n    margin-right: 5px;\n  }\n}\n\n/* 80% screen */\n@media (min-width: 1600px) and (max-width: 1740px) {\n  .firsttopenroll {\n    padding-top: 170px;\n  }\n\n  .firstarrow {\n    position: absolute;\n    left: 39.6%;\n    top: 148px;\n  }\n\n  .firstarrow2nd {\n    width: 183px;\n    height: 3px;\n    background-color: #156614;\n  }\n\n  /* second arrow */\n  .secondarrow {\n    position: absolute;\n    left: 52.8%;\n    top: 148px;\n  }\n\n  .secondarrow2nd {\n    width: 183px;\n    height: 3px;\n    background-color: #96c596;\n  }\n\n  .firstarrow2 {\n    position: absolute;\n    left: 39.6%;\n    top: 148px;\n  }\n\n  .secondarrow2 {\n    position: absolute;\n    left: 52.8%;\n    top: 148px;\n  }\n\n  .firstarrow21st {\n    width: 184px;\n    height: 3px;\n    background-color: #156614;\n  }\n\n  .secondarrow21st {\n    width: 184px;\n    height: 3px;\n    background-color: #96c596;\n  }\n\n  .firstarrow3 {\n    position: absolute;\n    left: 39.6%;\n    top: 148px;\n  }\n\n  .secondarrow3 {\n    position: absolute;\n    left: 52.8%;\n    top: 148px;\n  }\n\n  .thirdarrow3 {\n    width: 184px;\n    height: 3px;\n    background-color: #156614;\n  }\n\n  .thirdarrow32 {\n    width: 183px;\n    height: 3px;\n    background-color: #96c596;\n  }\n\n  .Enroll-top2 {\n    margin-top: 150px;\n  }\n\n  /* .Enroll-top {\n        margin-left: 250px; \n        margin-right: 250px;\n    } */\n\n  .Enroll-page {\n    background-color: #ffffff;\n    z-index: 100;\n    width: \"100%\";\n  }\n\n  .myfirstcon {\n    margin-top: 70px;\n    margin-bottom: 70px;\n    margin-left: 20px;\n    margin-right: 5px;\n  }\n\n  .sideshifft {\n    margin: \"50px\";\n  }\n\n  .textinputs {\n    border-radius: 10px;\n    background-color: #edecf8;\n    border: 1px solid #edecf8;\n    height: 40px;\n    width: 240px;\n  }\n\n  input:focus {\n    outline: none !important;\n    outline-width: 0 !important;\n    box-shadow: none;\n    -moz-box-shadow: none;\n    -webkit-box-shadow: none;\n  }\n\n  .formbtn {\n    width: 100px;\n    height: 35px;\n\n    margin-top: 15px;\n    background-color: #156614;\n    font-size: 13px;\n  }\n\n  .firstcontent {\n    margin-top: 70px;\n    margin-bottom: 70px;\n    margin-left: 20px;\n    margin-right: 5px;\n  }\n\n  .secondcontent {\n    margin-top: 70px;\n    margin-bottom: 70px;\n    margin-left: 20px;\n    margin-right: 5px;\n  }\n\n  .successtabs {\n    margin-top: 150px;\n    margin-bottom: 100px;\n    margin-left: 50px;\n    margin-right: 5px;\n  }\n}\n\n/* 75% screen */\n@media (min-width: 1790px) and (max-width: 1890px) {\n  .firsttopenroll {\n    padding-top: 170px;\n  }\n\n  .firstarrow {\n    position: absolute;\n    left: 40.3%;\n    top: 148px;\n  }\n\n  .firstarrow2nd {\n    width: 183px;\n    height: 3px;\n    background-color: #156614;\n  }\n\n  /* second arrow */\n  .secondarrow {\n    position: absolute;\n    left: 52.7%;\n    top: 148px;\n  }\n\n  .secondarrow2nd {\n    width: 183px;\n    height: 3px;\n    background-color: #96c596;\n  }\n\n  .firstarrow2 {\n    position: absolute;\n    left: 40.3%;\n    top: 148px;\n  }\n\n  .secondarrow2 {\n    position: absolute;\n    left: 52.7%;\n    top: 148px;\n  }\n\n  .firstarrow21st {\n    width: 184px;\n    height: 3px;\n    background-color: #156614;\n  }\n\n  .secondarrow21st {\n    width: 184px;\n    height: 3px;\n    background-color: #96c596;\n  }\n\n  .firstarrow3 {\n    position: absolute;\n    left: 40.3%;\n    top: 148px;\n  }\n\n  .secondarrow3 {\n    position: absolute;\n    left: 52.6%;\n    top: 148px;\n  }\n\n  .thirdarrow3 {\n    width: 184px;\n    height: 3px;\n    background-color: #156614;\n  }\n\n  .thirdarrow32 {\n    width: 183px;\n    height: 3px;\n    background-color: #96c596;\n  }\n\n  .Enroll-top2 {\n    margin-top: 150px;\n  }\n\n  /* .Enroll-top {\n        margin-left: 250px; \n        margin-right: 250px;\n    } */\n\n  .Enroll-page {\n    background-color: #ffffff;\n    z-index: 100;\n    width: \"100%\";\n  }\n\n  .myfirstcon {\n    margin-top: 70px;\n    margin-bottom: 70px;\n    margin-left: 20px;\n    margin-right: 5px;\n  }\n\n  .sideshifft {\n    margin: \"50px\";\n  }\n\n  .textinputs {\n    border-radius: 10px;\n    background-color: #edecf8;\n    border: 1px solid #edecf8;\n    height: 40px;\n    width: 240px;\n  }\n\n  input:focus {\n    outline: none !important;\n    outline-width: 0 !important;\n    box-shadow: none;\n    -moz-box-shadow: none;\n    -webkit-box-shadow: none;\n  }\n\n  .formbtn {\n    width: 100px;\n    height: 35px;\n\n    margin-top: 15px;\n    background-color: #156614;\n    font-size: 13px;\n  }\n\n  .firstcontent {\n    margin-top: 70px;\n    margin-bottom: 70px;\n    margin-left: 20px;\n    margin-right: 5px;\n  }\n\n  .secondcontent {\n    margin-top: 70px;\n    margin-bottom: 70px;\n    margin-left: 20px;\n    margin-right: 5px;\n  }\n\n  .successtabs {\n    margin-top: 150px;\n    margin-bottom: 100px;\n    margin-left: 50px;\n    margin-right: 5px;\n  }\n}\n\n/* 67% screen */\n@media (min-width: 1900px) and (max-width: 3000px) {\n  .firsttopenroll {\n    padding-top: 170px;\n  }\n\n  .firstarrow {\n    position: absolute;\n    left: 41.4%;\n    top: 148px;\n  }\n\n  .firstarrow2nd {\n    width: 183px;\n    height: 3px;\n    background-color: #156614;\n  }\n\n  /* second arrow */\n  .secondarrow {\n    position: absolute;\n    left: 52.3%;\n    top: 148px;\n  }\n\n  .secondarrow2nd {\n    width: 183px;\n    height: 3px;\n    background-color: #96c596;\n  }\n\n  .firstarrow2 {\n    position: absolute;\n    left: 41.3%;\n    top: 148px;\n  }\n\n  .secondarrow2 {\n    position: absolute;\n    left: 52.3%;\n    top: 148px;\n  }\n\n  .firstarrow21st {\n    width: 184px;\n    height: 3px;\n    background-color: #156614;\n  }\n\n  .secondarrow21st {\n    width: 184px;\n    height: 3px;\n    background-color: #96c596;\n  }\n\n  .firstarrow3 {\n    position: absolute;\n    left: 41.3%;\n    top: 148px;\n  }\n\n  .secondarrow3 {\n    position: absolute;\n    left: 52.3%;\n    top: 148px;\n  }\n\n  .thirdarrow3 {\n    width: 184px;\n    height: 3px;\n    background-color: #156614;\n  }\n\n  .thirdarrow32 {\n    width: 183px;\n    height: 3px;\n    background-color: #96c596;\n  }\n\n  .Enroll-top2 {\n    margin-top: 150px;\n  }\n\n  /* .Enroll-top {\n        margin-left: 250px; \n        margin-right: 250px;\n    } */\n\n  .Enroll-page {\n    background-color: #ffffff;\n    z-index: 100;\n    width: \"100%\";\n  }\n\n  .myfirstcon {\n    margin-top: 70px;\n    margin-bottom: 70px;\n    margin-left: 20px;\n    margin-right: 5px;\n  }\n\n  .sideshifft {\n    margin: \"50px\";\n  }\n\n  .textinputs {\n    border-radius: 10px;\n    background-color: #edecf8;\n    border: 1px solid #edecf8;\n    height: 40px;\n    width: 240px;\n  }\n\n  input:focus {\n    outline: none !important;\n    outline-width: 0 !important;\n    box-shadow: none;\n    -moz-box-shadow: none;\n    -webkit-box-shadow: none;\n  }\n\n  .formbtn {\n    width: 100px;\n    height: 35px;\n\n    margin-top: 15px;\n    background-color: #156614;\n    font-size: 13px;\n  }\n\n  .firstcontent {\n    margin-top: 70px;\n    margin-bottom: 70px;\n    margin-left: 20px;\n    margin-right: 5px;\n  }\n\n  .secondcontent {\n    margin-top: 70px;\n    margin-bottom: 70px;\n    margin-left: 20px;\n    margin-right: 5px;\n  }\n\n  .successtabs {\n    margin-top: 150px;\n    margin-bottom: 100px;\n    margin-left: 50px;\n    margin-right: 5px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
